/**
 * Organization Document Requests Page
 *
 * Displays ORGANIZATION tickets for the current customer.
 * Reuses the PendingTickets component with targetType=ORGANIZATION.
 */
import React from 'react';
import PendingTickets from '../../AdminType/Ticket/PendingTickets';

const MyDocumentRequestsPage = () => {
  return <PendingTickets targetType="ORGANIZATION" title="Organization Requests" />;
};

export default MyDocumentRequestsPage;
